<template>
  <div class="frontend">
    <div class="d-flex flex-column align-items-center justify-content-center vh-100 bg-light">
      <div class="d-flex flex-column align-items-center justify-content-center bg-light">
        <img
          :src="isMobile() ? logoMobileImg : logoImg"
          class="mb-3"
        >
        <h1 class="mb-3">
          Download Our App
        </h1>
      </div>
      <div class="d-flex flex-wrap align-items-center justify-content-center">
        <!-- Play Store Button -->
        <b-button
          variant="none"
          class="mx-2"
          href="https://play.google.com/store/apps/details?id=sg.com.nirvana.sgnirvana"
          target="_blank"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
            alt="Get it on Google Play"
            height="60"
          >
        </b-button>

        <!-- App Store Button -->
        <b-button
          variant="none"
          class="mx-2"
          href="https://apps.apple.com/us/app/nirvana-sg/id6740072042"
          target="_blank"
        >
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg"
            alt="Download on the App Store"
            height="60"
          >
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  components: {
    BButton,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      logoImg: require('@/assets/images/frontend/logo-orange-yellow-svg.svg'),
      // eslint-disable-next-line global-require
      logoMobileImg: require('@/assets/images/frontend/logo-orange-yellow-mobile.svg'),
    }
  },
}
</script>
